// Konvém: "Quanto levar para a festa" (F11, painel de 11/10/2026; versão nova do painel de 16/10/2026).
// Os dados vêm da seção kv-quanto-levar.
// Conta de cada item: pessoas ÷ "a cada" × quantidade (× horas ÷ horas da ocasião, se acompanha as horas;
// × 0,7 / 1 / 1,35 conforme a turma bebe, se o item é de álcool), para cima, no múltiplo e nunca abaixo do mínimo.
// O cliente muda a quantidade e troca o produto pela foto; "Pôr tudo no carrinho" usa o kvCesta.adicionar do
// konvem.js (abre a gaveta; o Leve Mais entra sozinho na cesta). O botão do WhatsApp manda a lista pronta com o
// link de volta (ocasião no #, pessoas e horas no endereço).
const raiz = document.querySelector('[data-kv-ql]');
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const reais = (c) => 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
const num = (t, pad) => { const n = parseFloat(String(t ?? '').replace(',', '.')); return Number.isFinite(n) ? n : pad; };
const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const calma = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

const FATOR = [0.7, 1, 1.35];
const GRUPOS = [['beber', 'Para beber'], ['comer', 'Para comer'], ['resto', 'Gelo e o resto']];
const PESSOA = '<svg viewBox="0 0 15 22" aria-hidden="true"><circle cx="7.5" cy="5" r="4" fill="currentColor"/><path d="M1 21c0-5 2.6-8.5 6.5-8.5S14 16 14 21z" fill="currentColor"/></svg>';

if (raiz) {
  let DADOS = [];
  try { DADOS = JSON.parse($('[data-kv-ql-dados]').textContent); } catch (e) { DADOS = []; }
  const campoP = $('[data-kv-ql-pessoas]', raiz);
  const estado = { o: 0, pessoas: 10, horas: 4, turma: 1, linhas: [], antes: {}, antesP: null, total: null, fechados: {} };

  // a ocasião aberta pode vir no endereço (#churrasco, #noite-de-vinho), e as pessoas e horas também (?pessoas=12&horas=5)
  const slug = (t) => String(t).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const disp = (it) => it.produtos.filter((p) => p.disponivel);
  const prod = (it, k) => { const ps = disp(it); return ps[estado.linhas[k].escolha] || ps[0]; };

  function sugerida(item, oc) {
    const cada = Math.max(num(item.a_cada, 1), 0.1);
    let q = estado.pessoas / cada * num(item.quantidade, 1);
    if (item.horas && oc.horas > 0) q = q * estado.horas / oc.horas;
    if (item.alcool) q *= FATOR[estado.turma];
    q = Math.ceil(q - 1e-9);
    const m = Math.max(1, item.multiplo || 1);
    q = Math.ceil(q / m) * m;
    return Math.max(q, item.minimo || 0);
  }
  function regra(item, oc) {
    const qtd = num(item.quantidade, 1), cada = num(item.a_cada, 1), u = item.unidade || 'unidades';
    const fmt = (n) => String(n).replace('.', ',');
    const un = qtd === 1 ? u.replace(/s$/, '').replace(/oe$/, 'ão') : u;
    let t = cada <= 1 ? `${fmt(qtd)} ${un} por pessoa` : `${fmt(qtd)} ${un} a cada ${fmt(cada)} pessoas`;
    if (item.horas && oc.horas > 0) t += ` em ${oc.horas} h`;
    return t;
  }
  // preço da linha com o Leve Mais (faixas do metacampo konvem.leve_mais: [{ qtd, preco }] por unidade)
  function precoLinha(p, q) {
    let unit = p.preco;
    for (const f of (p.faixas || [])) if (q >= f.qtd && f.preco < unit) unit = f.preco;
    return { cheio: p.preco * q, final: unit * q, unit };
  }
  function caixas(q) {
    const c12 = Math.floor(q / 12), r = q % 12, c6 = Math.floor(r / 6), u = r % 6;
    const partes = [];
    if (c12) partes.push(`${c12} ${c12 > 1 ? 'caixas' : 'caixa'} com 12`);
    if (c6) partes.push(`${c6} com 6`);
    if (u) partes.push(`${u} ${u > 1 ? 'latas' : 'lata'}`);
    return { c12, c6, texto: partes.join(' e ') };
  }

  function abrir(i, manter = false) {
    const oc = DADOS[i]; if (!oc) return;
    estado.o = i;
    if (!manter) { estado.pessoas = oc.pessoas || 10; estado.horas = oc.horas || 0; }
    estado.linhas = oc.itens.map(() => ({ escolha: 0, mexida: false, qtd: 0 }));
    estado.antes = {}; estado.fechados = {};
    $$('[data-kv-ql-ocasiao]', raiz).forEach((b) => b.setAttribute('aria-selected', String(+b.dataset.kvQlOcasiao === i)));
    $('[data-kv-ql-horas-caixa]', raiz).hidden = !(oc.horas > 0);
    const beber = $('[data-kv-ql-beber-caixa]', raiz);
    if (beber) beber.hidden = !oc.itens.some((it) => it.alcool && disp(it).length);
    desenhar();
  }

  function htmlItem(it, k, oc) {
    const ps = disp(it), p = prod(it, k), q = estado.linhas[k].qtd;
    const mudou = estado.antes[k] !== undefined && estado.antes[k] !== q;
    let meio = `<b class="kv-ql__rot">${esc(it.rotulo)}</b>`;
    if (ps.length > 1) {
      meio += `<div class="kv-ql__troca" role="group" aria-label="Trocar ${esc(it.rotulo)}">` + ps.map((x, j) =>
        `<button type="button" data-kv-ql-escolha="${k}" data-j="${j}" aria-pressed="${x === p}" aria-label="${esc(x.nome)}, ${reais(x.preco)}" title="${esc(x.nome)} · ${reais(x.preco)}"><img src="${esc(x.foto)}" alt="" width="40" height="40" loading="lazy"></button>`).join('') + '</div>';
      meio += `<span class="kv-ql__nome">${esc(p.nome)} · ${reais(p.preco)}</span>`;
    } else meio += `<span class="kv-ql__nome">${esc(p.nome)}</span>`;
    if (it.caixas && q > 0) {
      const c = caixas(q), v = precoLinha(p, q);
      meio += `<span class="kv-ql__caixas"><i aria-hidden="true">${'<u></u>'.repeat(Math.min(c.c12, 14))}${'<u class="kv-ql__meia"></u>'.repeat(c.c6)}</i>${c.texto}${v.unit < p.preco ? ` <small>${reais(v.unit)} a lata</small>` : ''}</span>`;
    } else meio += `<small class="kv-ql__regra">${esc(regra(it, oc))}</small>`;
    const passo = it.caixas ? 6 : 1;
    return `<li class="kv-ql__item${q === 0 ? ' kv-ql__item--fora' : ''}${mudou ? ' kv-ql__item--mudou' : ''}" data-kv-ql-item="${k}">
      <a class="kv-ql__foto" href="${esc(p.url)}" tabindex="-1" aria-hidden="true"><img src="${esc(p.foto)}" alt="" width="64" height="64" loading="lazy"></a>
      <div class="kv-ql__meio">${meio}</div>
      <div class="kv-ql__qtd"><div class="kv-passo kv-passo--p">
        <button type="button" data-kv-ql-linha="${k}" data-passo="-${passo}" aria-label="Menos ${esc(it.rotulo)}">−</button>
        <input type="number" min="0" max="999" inputmode="numeric" data-kv-ql-q="${k}" value="${q}" aria-label="Quantidade de ${esc(it.rotulo)}"${mudou ? ' class="kv-ql__tique"' : ''}>
        <button type="button" data-kv-ql-linha="${k}" data-passo="${passo}" aria-label="Mais ${esc(it.rotulo)}">+</button>
      </div><span class="kv-ql__preco" data-kv-ql-preco="${k}"></span></div>
    </li>`;
  }

  function desenhar() {
    const oc = DADOS[estado.o]; if (!oc) return;
    oc.itens.forEach((it, k) => { const l = estado.linhas[k]; if (!l.mexida) l.qtd = sugerida(it, oc); });

    // controles
    campoP.value = estado.pessoas;
    $$('[data-kv-ql-por]', raiz).forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.valor === estado[b.dataset.kvQlPor])));
    $$('[data-kv-ql-turma-b]', raiz).forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.kvQlTurmaB === estado.turma)));
    const bebe = $('[data-kv-ql-beber-caixa]', raiz), comAlcool = bebe && !bebe.hidden;
    const n = estado.pessoas, max = 30, antesP = estado.antesP ?? n;
    const bebem = comAlcool ? Math.round(n * [0.5, 0.75, 0.9][estado.turma]) : 0;
    let t = '';
    for (let i = 0; i < Math.min(n, max); i++) {
      const cls = [i < bebem ? 'kv-ql__bebe' : '', i >= antesP ? 'kv-ql__entra' : ''].join(' ').trim();
      t += PESSOA.replace('<svg', `<svg${cls ? ` class="${cls}"` : ''}${i >= antesP ? ` style="animation-delay:${(i - antesP) * 25}ms"` : ''}`);
    }
    if (n > max) t += `<em>+${n - max}</em>`;
    $('[data-kv-ql-turma]', raiz).innerHTML = t;

    const resumo = (oc.resumo || `${oc.nome} para {pessoas} pessoas`).replace('{pessoas}', estado.pessoas).replace('{horas}', estado.horas);
    $('[data-kv-ql-resumo]', raiz).textContent = resumo;

    // lista em grupos
    const vis = oc.itens.map((it, k) => ({ it, k })).filter(({ it }) => disp(it).length);
    const subtotal = (g) => vis.filter(({ it }) => (it.grupo || 'beber') === g).reduce((s, { it, k }) => s + precoLinha(prod(it, k), estado.linhas[k].qtd).final, 0);
    const caixaLista = $('[data-kv-ql-lista]', raiz);
    caixaLista.innerHTML = GRUPOS.map(([g, nome]) => {
      const its = vis.filter(({ it }) => (it.grupo || 'beber') === g); if (!its.length) return '';
      return `<details class="kv-ql__grupo" data-kv-ql-grupo="${g}"${estado.fechados[g] ? '' : ' open'}><summary><b>${nome}</b><span>${its.length} ${its.length > 1 ? 'itens' : 'item'} · ${reais(subtotal(g))}</span></summary>
        <ul class="kv-ql__itens">${its.map(({ it, k }) => htmlItem(it, k, oc)).join('')}</ul></details>`;
    }).join('');
    const ex = $('[data-kv-ql-extra]', raiz);
    ex.hidden = !oc.extra_texto;
    ex.innerHTML = oc.extra_texto ? (oc.extra_link ? `<a href="${esc(oc.extra_link)}">${esc(oc.extra_texto)}</a>` : esc(oc.extra_texto)) : '';

    // preços e total
    let total = 0, cheio = 0; const linhasZap = [];
    vis.forEach(({ it, k }) => {
      const p = prod(it, k), q = estado.linhas[k].qtd, v = precoLinha(p, q);
      total += v.final; cheio += v.cheio;
      if (q) linhasZap.push(`• ${q} × ${p.nome}`);
      const el = $(`[data-kv-ql-preco="${k}"]`, caixaLista);
      if (el) el.innerHTML = q ? (v.final < v.cheio ? `<s>${reais(v.cheio)}</s> ${reais(v.final)}` : reais(v.final)) : '<span>fora</span>';
    });
    correTotal(total);
    const eco = $('[data-kv-ql-economia]', raiz);
    eco.hidden = !(cheio > total); eco.textContent = cheio > total ? `Leve Mais: ${reais(cheio - total)} a menos` : '';
    $('[data-kv-ql-por-tudo]', raiz).disabled = total === 0;

    // WhatsApp: a lista pronta, com o link de volta para a mesma conta
    const volta = new URL(location.origin + location.pathname);
    volta.searchParams.set('pessoas', estado.pessoas);
    if (oc.horas > 0) volta.searchParams.set('horas', estado.horas);
    volta.hash = slug(oc.nome);
    const msg = `Lista da Konvém: ${resumo}\n\n${linhasZap.join('\n')}\n\nTotal: ${reais(total)}\nMonte a sua: ${volta.href}`;
    $('[data-kv-ql-zap]', raiz).href = 'https://wa.me/?text=' + encodeURIComponent(msg);

    oc.itens.forEach((it, k) => { estado.antes[k] = estado.linhas[k].qtd; });
    estado.antesP = estado.pessoas;
  }

  // o total corre até o valor novo (sem movimento, troca direto)
  let corrida = 0;
  function correTotal(alvo) {
    const el = $('[data-kv-ql-total]', raiz);
    const de = estado.total;
    if (de === null || de === alvo || calma()) { estado.total = alvo; el.textContent = reais(alvo); return; }
    const t0 = performance.now(), id = ++corrida;
    const passo = (t) => {
      if (id !== corrida) return;
      const x = Math.min(1, (t - t0) / 450), e = 1 - Math.pow(1 - x, 3);
      estado.total = Math.round(de + (alvo - de) * e);
      el.textContent = reais(estado.total);
      if (x < 1) requestAnimationFrame(passo); else estado.total = alvo;
    };
    requestAnimationFrame(passo);
  }

  // as fotos voam até o carrinho do topo (ou da barra do celular), enquanto o pedido já vai para a cesta
  function voar() {
    if (calma()) return;
    const alvo = $$('[data-kv-abrir-cesta]').map((a) => a.getBoundingClientRect()).find((r) => r.width > 0 && r.bottom > 0 && r.top < innerHeight);
    if (!alvo) return;
    const fotos = $$('.kv-ql__item:not(.kv-ql__item--fora) .kv-ql__foto img', raiz).filter((im) => { const r = im.getBoundingClientRect(); return r.width && r.bottom > 0 && r.top < innerHeight; }).slice(0, 6);
    fotos.forEach((im, i) => {
      const r = im.getBoundingClientRect(), v = im.cloneNode();
      v.className = 'kv-ql__voa'; v.removeAttribute('loading');
      Object.assign(v.style, { left: r.left + 'px', top: r.top + 'px', width: r.width + 'px', height: r.height + 'px' });
      document.body.appendChild(v);
      const dx = alvo.left + alvo.width / 2 - (r.left + r.width / 2), dy = alvo.top + alvo.height / 2 - (r.top + r.height / 2);
      setTimeout(() => { v.style.transform = `translate(${dx}px, ${dy}px) scale(.25)`; v.style.opacity = '.2'; }, 20 + i * 70);
      setTimeout(() => v.remove(), 900 + i * 70);
    });
  }

  // a lista é redesenhada a cada mudança: devolve o foco ao mesmo botão (teclado)
  function refoca(el) {
    if (!el || !el.dataset) return;
    const chave = ['kvQlLinha', 'kvQlEscolha', 'kvQlPor', 'kvQlTurmaB'].find((c) => el.dataset[c] !== undefined);
    if (!chave) return;
    const attr = 'data-' + chave.replace(/[A-Z]/g, (c) => '-' + c.toLowerCase());
    const extra = el.dataset.j !== undefined ? `[data-j="${el.dataset.j}"]` : el.dataset.passo !== undefined ? `[data-passo="${el.dataset.passo}"]` : el.dataset.valor !== undefined ? `[data-valor="${el.dataset.valor}"]` : '';
    const novo = raiz.querySelector(`[${attr}="${el.dataset[chave]}"]${extra}`);
    if (novo && novo !== el) novo.focus({ preventScroll: true });
  }
  raiz.addEventListener('click', (ev) => {
    const foco = document.activeElement;
    queueMicrotask(() => { if (foco && !raiz.contains(foco)) refoca(foco); });
    const oc = ev.target.closest('[data-kv-ql-ocasiao]');
    if (oc) { estado.antesP = null; abrir(+oc.dataset.kvQlOcasiao); history.replaceState(null, '', location.pathname + '#' + slug(DADOS[estado.o].nome)); return; }
    const m = ev.target.closest('[data-kv-ql-mudar]');
    if (m) { const k = m.dataset.kvQlMudar; estado[k] = Math.min(k === 'pessoas' ? 200 : 24, Math.max(1, estado[k] + +m.dataset.passo)); desenhar(); return; }
    const a = ev.target.closest('[data-kv-ql-por]');
    if (a) { estado[a.dataset.kvQlPor] = +a.dataset.valor; desenhar(); return; }
    const tb = ev.target.closest('[data-kv-ql-turma-b]');
    if (tb) { estado.turma = +tb.dataset.kvQlTurmaB; desenhar(); return; }
    const l = ev.target.closest('[data-kv-ql-linha]');
    if (l) { const li = estado.linhas[+l.dataset.kvQlLinha]; li.qtd = Math.max(0, li.qtd + +l.dataset.passo); li.mexida = true; desenhar(); return; }
    const e = ev.target.closest('[data-kv-ql-escolha]');
    if (e) { estado.linhas[+e.dataset.kvQlEscolha].escolha = +e.dataset.j; desenhar(); return; }
    if (ev.target.closest('[data-kv-ql-por-tudo]')) por();
  });
  raiz.addEventListener('toggle', (ev) => { const d = ev.target; if (d.dataset && d.dataset.kvQlGrupo) estado.fechados[d.dataset.kvQlGrupo] = !d.open; }, true);
  raiz.addEventListener('change', (ev) => {
    const q = ev.target.closest('[data-kv-ql-q]');
    if (q) { const li = estado.linhas[+q.dataset.kvQlQ]; li.qtd = Math.max(0, Math.round(num(q.value, 0))); li.mexida = true; desenhar(); return; }
    if (ev.target === campoP) { estado.pessoas = Math.min(200, Math.max(1, Math.round(num(campoP.value, 1)))); desenhar(); }
  });

  async function por() {
    const oc = DADOS[estado.o]; const b = $('[data-kv-ql-por-tudo]', raiz); const msg = $('[data-kv-ql-msg]', raiz);
    const itens = [];
    oc.itens.forEach((it, k) => { if (!disp(it).length) return; const p = prod(it, k); const q = estado.linhas[k].qtd; if (p && q > 0) itens.push({ id: p.id, quantity: q }); });
    if (!itens.length || !window.kvCesta) return;
    b.disabled = true; b.setAttribute('aria-busy', 'true'); msg.hidden = true;
    voar();
    try {
      await window.kvCesta.adicionar(itens, { abrir: 'sempre' });
    } catch (e) {
      // um item sem estoque derruba o pedido inteiro na Shopify: vai um por um e conta o que ficou de fora
      const fora = [];
      for (const it of itens) {
        try { await window.kvCesta.adicionar([it], { abrir: false }); } catch (e2) { fora.push(e2.message); }
      }
      if (fora.length < itens.length) window.kvCesta.abrirCesta && window.kvCesta.abrirCesta();
      msg.textContent = fora.length ? `Parte foi para o carrinho. ${fora[0]}` : ''; msg.hidden = !fora.length;
    } finally { b.disabled = false; b.removeAttribute('aria-busy'); }
  }

  const busca = new URLSearchParams(location.search);
  const inicio = DADOS.findIndex((o) => slug(o.nome) === location.hash.slice(1));
  abrir(inicio >= 0 ? inicio : 0);
  const bp = Math.round(num(busca.get('pessoas'), 0)), bh = Math.round(num(busca.get('horas'), 0));
  if (bp > 0 || bh > 0) {
    if (bp > 0) estado.pessoas = Math.min(200, bp);
    if (bh > 0 && DADOS[estado.o] && DADOS[estado.o].horas > 0) estado.horas = Math.min(24, bh);
    estado.antesP = null; desenhar();
  }
}
